import React from "react"

import BackgroundImage from "../../../common/BackgroundImage"
import ShortTextWithReadMore from "../../../common/ShortTextWithReadMore"
import ContentLoaderLines from "../../../common/content-loading/ContentLoaderLines"

const UserViewItemDetails = ({
    first_name,
    last_name,
    status,
    primary_organisation,
    primary_position,
    bio,
    photo_url,
    isFetching
}) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <i className="icon icon-headline" />First Name
            </h3>
            <ContentLoaderLines
                isFetching={isFetching}
                minLineLength={20}
                maxLineLength={50}
            >
                <p>{first_name || "No name"}</p>
            </ContentLoaderLines>
            <h3>
                <i className="icon icon-headline" />Last Name
            </h3>
            <ContentLoaderLines
                isFetching={isFetching}
                minLineLength={20}
                maxLineLength={50}
            >
                <p>{last_name || "No name"}</p>
            </ContentLoaderLines>
            <h3>
                <i className="icon icon-status" />Status
            </h3>
            <ContentLoaderLines isFetching={isFetching} lineLength={30}>
                <p>{status || "No status"}</p>
            </ContentLoaderLines>
            <h3>
                <i className="icon icon-user-primary-org" />Primary Organisation
            </h3>
            <ContentLoaderLines isFetching={isFetching} minLineLength={30}>
                <p>{primary_organisation || "No organisation"}</p>
            </ContentLoaderLines>
            <h3>
                <i className="icon icon-user-primary-position" />Primary
                Position
            </h3>
            <ContentLoaderLines isFetching={isFetching} minLineLength={30}>
                <p>{primary_position || "No position"}</p>
            </ContentLoaderLines>
            <h3>
                <i className="icon icon-description" />Bio
            </h3>
            <ContentLoaderLines
                isFetching={isFetching}
                minLines={2}
                maxLines={5}
            >
                <ShortTextWithReadMore text={bio} placeholder="No bio" />
            </ContentLoaderLines>
            <h3>
                <i className="icon icon-heroimg" />User Picture
            </h3>
            <BackgroundImage
                classList={[
                    "item-background-image thumb-rounded full-background-opacity"
                ]}
                imageUrl={photo_url}
                isThumbnail={true}
            />
        </div>
    </div>
)

export default UserViewItemDetails
